module.exports = require("./ng-tags-input.js");
require("./ng-tags-input.css");


/*****************
 ** WEBPACK FOOTER
 ** ng-tags-input (bower component)
 ** module id = 379
 ** module chunks = 1
 **/